import { IAccountingMappingStationList } from '@modules/accounting-and-finance/interface/account-mapping/accounting-mapping-interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IAccountingMappingStationList[] = [];

export const ACCGStationsSlice = createSlice({
  name: 'accgStation',
  initialState,
  reducers: {
    setACCGStation: (
      _state,
      action: PayloadAction<IAccountingMappingStationList[]>,
    ) => {
      return [...action.payload];
    },
    removeACCGStation: () => {
      return initialState;
    },
  },
});

export default ACCGStationsSlice.reducer;

export const { setACCGStation, removeACCGStation } = ACCGStationsSlice.actions;
